import { PageProps } from 'gatsby'
import { Detail } from 'components/customers'
import { SEO } from 'components/common'

export const Head = () => <SEO title={'顧客（法人・団体）詳細'} />

const IndexPage = ({
  params: { id },
}: PageProps<Queries.Query>): JSX.Element => {
  return (
    <>
      <Detail id={id} type="corporate" />
    </>
  )
}

export default IndexPage
